var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "we-chat-auth-dialog",
      attrs: { title: "", visible: _vm.innerVisible, "append-to-body": "" },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "div",
        [
          _c("h2", [_vm._v(_vm._s(_vm.$t("Tool.WeChatPushRemindTitle")))]),
          _c("el-image", {
            staticStyle: { width: "150px" },
            attrs: { src: _vm.url }
          }),
          _c("p", [_vm._v(_vm._s(_vm.$t("Message.Tips")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("Tool.WeChatPushRemind1")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("Tool.WeChatPushRemind2")))])
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.change } },
            [_vm._v(_vm._s(_vm.$t("Tool.IveFollowed")))]
          ),
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }